export const SET_USER_LIST = 'SET_USER_LIST';
export const SET_USER_LIST_PAGE_INFO = 'SET_USER_LIST_PAGE_INFO';

export const SET_INVITE_CODE = 'SET_INVITE_CODE';

export const SET_ROLE_LIST = 'SET_ROLE_LIST';

// 页码区域
export const SET_Q_CROWD_PAGE_SIZE = 'SET_Q_CROWD_PAGE_SIZE';
export const SET_Q_CROWD_PAGE_COUNT = 'SET_Q_CROWD_PAGE_COUNT';
export const SET_Q_CROWD_PAGE_TOTAL = 'SET_Q_CROWD_PAGE_TOTAL';
